import isEqual from 'lodash/isEqual';
import React from 'react';
import { fileTypeToIconMap } from '../features/file-manager';
export const FileTypeIcon = ({ row, defaultPermissions }) => {
    const iconKey = getIconKey(row, defaultPermissions);
    if (!iconKey)
        return null;
    const { icon: Icon, color } = fileTypeToIconMap[iconKey];
    const isIconEnabled = row.permissions.includes('read');
    const sx = isIconEnabled ? { color } : { color: 'disabled' };
    return React.createElement(Icon, { sx: sx });
};
const getIconKey = (row, defaultPermissions) => {
    const isDirectory = row.columns.directory;
    const isShared = row.columns.permissions && !isEqual(JSON.parse(row.columns.permissions), defaultPermissions);
    const isImage = row.columns.type.startsWith('image/');
    if (isDirectory && isShared)
        return 'sharedFolder';
    if (isDirectory && !isShared)
        return 'folder';
    if (isImage && isShared)
        return 'sharedImage';
    if (isImage && !isShared)
        return 'image';
    if (!isImage && isShared)
        return 'sharedFile';
    if (!isImage && !isShared)
        return 'file';
    return null;
};
